// extracted by mini-css-extract-plugin
export var found = "DeliveryNoteItem-module--found--m1Vq6";
export var iconWrapper = "DeliveryNoteItem-module--iconWrapper--vhEPw";
export var imageWrapper = "DeliveryNoteItem-module--imageWrapper--pHprg";
export var noItems = "DeliveryNoteItem-module--noItems--EjKH7";
export var noteOrderStatus = "DeliveryNoteItem-module--noteOrderStatus--igbrQ";
export var notfound = "DeliveryNoteItem-module--notfound--ByYPr";